import { render, staticRenderFns } from "./HiddenLessons.vue?vue&type=template&id=6caeae62&"
import script from "./HiddenLessons.vue?vue&type=script&lang=js&"
export * from "./HiddenLessons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports